import { Pipe, PipeTransform } from "@angular/core";
import { NsEmpWebExpData } from "../models/emp-web-exp.model";

@Pipe({
  name: "checkLanguage"
})
export class CheckLanguagePipe implements PipeTransform {
  transform(value: string, languages: NsEmpWebExpData.ILocaleList[]): boolean {
    return languages?.[0]?.code === value;
  }
}
